// Tabla de búsqueda para mensajes
export const MESSAGE_LOOKUP: Record<string, Record<'origin' | 'destination' | 'default', string>> = {
  airport: {
    origin: 'Arribo del vuelo',
    destination: 'Salida del vuelo',
    default: 'Hora del pickup'
  },
  hotel: {
    origin: 'Hora del pickup',
    destination: 'Hora del pickup',
    default: 'Hora del pickup'
  },
  city: {
    origin: 'Hora del pickup',
    destination: 'Hora del pickup',
    default: 'Hora del pickup'
  },
  port: {
    origin: 'LLegada embarque',
    destination: 'Hora del embarque',
    default: 'Hora del pickup'
  },
  train: {
    origin: 'Hora de llegada',
    destination: 'Hora de salida',
    default: 'Hora del pickup'
  },
  bus: {
    origin: 'Hora de llegada',
    destination: 'Hora de salida',
    default: 'Hora del pickup'
  },
  restaurant: {
    origin: 'Hora del pickup',
    destination: 'Hora fin salida',
    default: 'Hora del pickup'
  },
  attraction: {
    origin: 'Hora del pickup',
    destination: 'Hora fin visita',
    default: 'Hora del pickup'
  }
};
